import { defineMessages, useIntl } from "react-intl";
import { IconMessageCircleQuestion } from "@tabler/icons-react";
import { BasicPrice, Image } from "@shared/graphql";
import { DataProps } from "../../../tools/components";
import { useTools } from "../../../hooks/tools";
import { Overlay } from "../../layout/overlays";
import ContactForm from "../../contact-form";
import "./contact-form.scss";
import Button from "../../common/button";
import { ReactNode, useRef, useState } from "react";
import RatioImage from "../../medias/ratio-image";
import { TranslatedString } from "@ct-react/core";
import ArticleResume, { ArticleResumeProps } from "../../article-resume";

const transDefs = defineMessages({
  action: { id: "article.aside-contact.action", defaultMessage: "Entrer en contact" }
});

type Props = DataProps<InnerProps> & {
  resume: ArticleResumeProps;
  activator?: boolean;
}

type InnerProps = {
  articleId: string;
  price?: BasicPrice;
}

const ContactFormAside = ({ activator, resume, data }: Props) => {

  const intl = useIntl();
  const { format } = useTools();

  const [ open, setOpen ] = useState<boolean>(false);

  return (
    <Overlay.StickableBottom {...{ activator, open, setOpen }}>

      <Overlay.StickableContent title={intl.formatMessage(transDefs.action)}>
        {activator && <ArticleResume data={resume} />}
        <ContactForm className="article-asidable" data={{ articleId: data.articleId }} />
      </Overlay.StickableContent>

      <Overlay.StickableResume className="contact"
                               icon={IconMessageCircleQuestion}>
        <span className="price">{format.anyPrice(data.price)}</span>
        <Button type="button" className="small light lower" onClick={() => setOpen(true)}>
          {intl.formatMessage(transDefs.action)}
        </Button>
      </Overlay.StickableResume>

    </Overlay.StickableBottom>);

}

export default ContactFormAside;
